export function loadChart(
  myChart,
  xData,
  line,
  unit = "人数",
  haszoom = false,
  sname = "采购商",
  tname = ""
) {
  if (myChart) {
    myChart.clear();
  }
  if (xData.length > 0) {
    let dataZoom = [];
    if (haszoom) {
      dataZoom = [
        {
          start: 0,
          end: 60,
          zoomLock: true
        },
        {
          type: "inside"
        }
      ];
    } else {
      if (xData.length > 15) {
        const shownum = 14;
        const okbfb = Math.ceil((shownum / xData.length) * 100);
        dataZoom = [
          {
            start: 100 - okbfb,
            end: 100,
            zoomLock: true
          },
          {
            type: "inside"
          }
        ];
      }
    }

    const title = {
      show: tname !== "",
      text: tname,
      textStyle: {
        color: "#7bbef6",
        fontSize: 14
      },
      left: "center"
    };
    // 设置
    myChart.setOption({
      baseOption: {
        title,
        color: [
          "#37C779",
          "#66CCFF",
          "#CC6666",
          "#66CCCC",
          "#FF9999",
          "#CCFF99"
        ],
        timeline: {
          show: false,
          axisType: "category",
          data: []
        },
        tooltip: {},
        // legend: {
        //   left: "right",
        //   data: ["第一产业"]
        // },
        calculable: true,
        grid: {
          top: 30,
          bottom: 30,
          right: 8,
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              label: {
                show: true
              }
            }
          }
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              interval: 0,
              textStyle: {
                //改变xy轴上文字的颜色
                color: "#FFF"
              },
              formatter: function(data) {
                // eslint-disable-next-line no-useless-escape
                return data.replace(/\-/, "/");
              }
            },
            data: line || [
              "北京",
              "\n天津",
              "河北",
              "\n山西",
              "内蒙古",
              "\n辽宁",
              "吉林",
              "\n黑龙江",
              "上海",
              "\n江苏",
              "浙江",
              "\n安徽",
              "福建",
              "\n江西",
              "山东",
              "\n河南",
              "湖北",
              "\n湖南",
              "广东",
              "\n广西",
              "海南",
              "\n重庆",
              "四川",
              "\n贵州",
              "云南",
              "\n西藏",
              "陕西",
              "\n甘肃",
              "青海",
              "\n宁夏",
              "新疆"
            ],
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: unit,
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10
            },
            axisLabel: {
              textStyle: {
                //改变xy轴上文字的颜色
                color: "#FFF"
              }
            }
          }
        ],
        dataZoom,
        series: [
          {
            name: sname,
            type: "bar"
          }
        ]
      },
      options: [
        {
          series: [
            {
              data: xData
            }
          ]
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
